import { createSlice } from "@reduxjs/toolkit";

const fetchAirline = {};

const FetchAirlineSlice = createSlice({
    name: "fetchAirline",
    initialState: {
        fetchAirline
    },
    reducers: {
        reSetFetchAirline(state, action){
            state.fetchAirline = {}
        },
        setFetchAirline(state, action) {
            state.fetchAirline = action.payload;
        },
    }
});

export const {
    setFetchAirline,
    reSetFetchAirline
} = FetchAirlineSlice.actions;

export default FetchAirlineSlice.reducer;